export const OK_TO_BOARD = 'OK TO BOARD';

export const SEAT_ANCILLARY_CODE = '0B5';

export const IROPS_TYPE = 'YY';

export const IROPS_REMARK = 'OPERATIONALIROPDELAYEDDIGITAL';

export const CHECKIN_WINDOW = {
  DOMESTIC_CLOSING_MINUTES: 60,
  INTERNATIONAL_CLOSING_MINUTES: 60,
};
export const CODES_OVERWEIGHT = ['OW2', '0FG', '0EZ', '0C6', '0C9'];
